import AuthenticatedRoute from 'fabscale-app/routes/base/-base-authenticated-route';

export default class RoutesReportsAlarm extends AuthenticatedRoute {}
